export default {
  studentTopicLearn: {
    id: "",
    studentUnitLearn: null,
    studentEnrollDetail: null,
    vdoSetUnit: null,
    vdoSetTopic: null,
    vdoLength: null,
    learnTime: null,
    firstPlayVdo: null,
    startPlayVdo: null,
    stopPlayVdo: null,
    learnPercent: null,
  },

  studentTopicLearns: [],
  processing: false,
  error: null,
  success: null,
}



